import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaCalendarAlt, FaCheckCircle, FaClock, FaMoneyBillWave, FaPercent, FaTag, FaVial } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import defaultImage from "../../images/Assets/locaTion2.jpg";

const CardPackage = ({ packageData }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const time = packageData.endDate && packageData.StartDate
  const packageSale = packageData?.onSale;
  const now = new Date();
  const end = new Date(packageData.endDate);
  const timeDiff = end - now;
  const formattedStartDate = packageData.startDate ? moment(packageData.startDate).format('DD MMM YYYY') : null;
  const formattedEndDate = packageData.endDate ? moment(packageData.endDate).format('DD MMM YYYY') : null;
console.log("",packageData.image);

  const isExpired = end && end < now;

  // Handle booking navigation
  const handleBooking = () => {
    navigate('/package/booking', { state: packageData });
  };

  // Calculate days left for the sale
  const calculateTimeLeft = () => {
    if (timeDiff <= 0) return t('details.expired');
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))+1;
    return `${days} ${t('days')}`;
  };

  // Optimized function to handle expired offers
  const handleExpiredOffers = useCallback(async () => {
    if (packageSale && isExpired) {
      try {
        await axios.patch(`http://localhost:4200/api/v1/package/find/${packageData._id}`, {
          onSale: false,
        });
      } catch (error) {
        // console.error('Error updating package sale status:', error);
      }
    }
  }, [packageSale, isExpired, packageData._id]);

  useEffect(() => {
    if (isExpired && time) {
      handleExpiredOffers();
    }
  }, [handleExpiredOffers]);

  return (
    <div className="group bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden flex flex-col">

  {/* Image */}
  <div
    className="relative aspect-[4/3] overflow-hidden"
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
  >
    <img
      src={packageData.image || defaultImage}
      alt={i18n.language === 'ar' ? packageData.name_ar : packageData.name_en}
      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
    />

    {/* Sale Badge */}
    {packageSale && (
      <span className="absolute top-3 left-3 bg-red-600 text-white text-xs md:text-sm px-3 py-1 rounded-full flex items-center gap-1 shadow-lg">
        <FaTag />
        {t('packages.onSale')}
      </span>
    )}

    {/* Overlay */}
    {packageSale && (
      <div className={`
        absolute inset-0 bg-black/70 backdrop-blur-sm
        flex flex-col items-center justify-center gap-3
        text-white text-sm
        transition-all duration-500
        ${isHovered ? 'opacity-100' : 'opacity-0'}
        hidden md:flex
      `}>

        {packageData.priceSale && (
          <div className="flex items-center gap-2 text-yellow-400 text-lg font-bold">
            <FaTag />
            {packageData.priceSale} {t('currency')}
          </div>
        )}

        {packageData.salePercent && (
          <div className="flex items-center gap-2 text-green-400">
            <FaPercent />
            {packageData.salePercent}%
          </div>
        )}

        {time && (
          <div className="flex items-center gap-2 text-blue-300">
            <FaClock />
            {calculateTimeLeft()}
          </div>
        )}
      </div>
    )}
  </div>

  {/* Content */}
  <div className="flex flex-col flex-grow p-4 gap-3">

    <h3 className="text-base md:text-lg font-bold text-secondColor line-clamp-2">
      {i18n.language === 'ar' ? packageData.name_ar : packageData.name_en}
    </h3>

    

    {
      packageData.tests&&(
        <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-3 py-2 text-sm">
      <FaVial className="text-primeColor-500" />
      <span>
        {t('packages.test')}: <b>{packageData.tests}</b>
      </span>
    </div>
      )
    }
    {packageData?.price > 0 && (
  <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-3 py-2 text-sm">
    <FaMoneyBillWave className="text-green-600" />
    <span>
      {t("packages.price")}:{" "}
      <b>
        {packageData.price} 
        <span className="text-xs text-gray-500 ms-1">{t("currency")}</span>
      </b>
    </span>
  </div>
)}


    {/* Dates (Mobile Friendly) */}
    {formattedEndDate && (
      <div className="text-xs text-gray-500 flex items-center gap-2">
        <FaCalendarAlt />
        {formattedStartDate} → {formattedEndDate}
      </div>
    )}

    {/* Actions */}
    <div className="mt-auto flex flex-col sm:flex-row gap-3">
      <button
        onClick={handleBooking}
        className="flex-1 bg-secondColor text-white py-2 rounded-xl text-sm font-semibold hover:bg-secondColor/90 transition"
      >
        {t('packages.bookNow')}
      </button>

      <Link
        to="/package/detail"
        state={packageData}
        className="flex-1 text-center bg-primeColor-500 text-white py-2 rounded-xl text-sm font-semibold hover:bg-primeColor-500/90 transition"
      >
        {t('packages.more')}
      </Link>
    </div>

  </div>
</div>

  );
};

export default CardPackage;
